import styled, { css } from 'styled-components';

export type TagVariant = 'filled' | 'subtle';

interface STagContainerProps {
    $color?: string;
    $variant: TagVariant;
}

export const STagContainer = styled.span<STagContainerProps>`
    display: inline-flex;
    align-items: center;
    width: fit-content;
    border-radius: 50px;
    padding: 2px 8px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.4;
    white-space: nowrap;

    ${({ $variant, $color, theme }) =>
        $variant === 'subtle'
            ? css`
                  background-color: ${theme.color.secondary.light};
                  color: ${theme.color.secondary.dark};
              `
            : css`
                  background-color: ${$color};
                  color: white;
              `}
`;
